import { GlobalStorage } from '@feedyou/schema'
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { botFlowSelector } from '../../../store/flow/selectors/botFlowSelector'

export const useGlobalStorage = (name: string | undefined): GlobalStorage | undefined => {
  return useSelector((state: RootState) => botFlowSelector(state)?.globalStorages?.[name!])
}
